/**
 @author: 菩萨蛮
 @date: 2019-05-27-11:27
 @version: V1.0.0
 */

import router from '../router';
import CONSTANT from '../constant/constant';
import i18n from '../i18n/index';

const m = (title, icon, show, permission, value, component,
           hasGroup, add, needAdd, addPermission) => (
  { title, icon, show, permission, value, component, hasGroup, add, needAdd, addPermission }
);
const m2 = (title, component, show, add, needAdd, permission, addPermission) => (
  { title, component, show, add, needAdd, permission, addPermission }
);
const isCurrentLang = (lang) => {
  const curLang = localStorage.getItem('lang');
  return curLang === lang;
}


const getMenu = () => [
  m('首页', '', false, '', [
    m2('首页', 'index', false, false, false),
    m2(i18n.t('tabs.changePassword'), 'change-password', false, false, false),
  ]),
  m(i18n.t('tabs.purchasingModule'), 'el-icon-third-jihua', true, '', [
    m2('采购订单', 'sale-order', true, false, false, ''),
    m2('查看采购订单', 'detail-sale-order', false, false, false, ''),
    m2('大货发货通知单', 'notice-order-dahuo', isCurrentLang('zh'), false, false,''),
    m2('样品发货通知单', 'notice-order-mayang', isCurrentLang('zh'), false, false,''),
    m2('新增大货发货通知单', 'new-notice-order-dahuo', false, false, false),
    m2('修改大货发货通知单', 'modify-notice-order-dahuo', false, false, false),
    m2('新增样品发货通知单', 'new-notice-order-mayang', false, false, false),
    m2('修改样品发货通知单', 'modify-notice-order-mayang', false, false, false),
    m2('待发货清单', 'order-stock', true, false, false, ''),
    m2('对账清单', 'reconciliation-checklist', true, false, false, ''),
    m2('查看对账清单', 'detail-reconciliation-checklist', false, false, false, ''),
    m2('查看对账清单(未出账)', 'detail-unbilled-reconciliation-checklist', false, false, false, ''),
    // m2('面料库', 'product-query', true, false, false, ''),
    m2(i18n.t('tabs.inquireGoods'), 'goods', true, false, false, ''),
  ]),
];

const state = {
  tabs: [],
  view: {},
  update: false,
  menu: getMenu()
};

const setKeepAliveTabs = s => {
  s.keepAliveTabs = s.tabs.map(a => {
    const t = a.component;
    return t.split('-')
      .map(q => `${q[0].toLocaleUpperCase()}${q.slice(1, q.length)}`)
      .join('');
  }).join(',');
};

/**
 * 获取标题
 * @param component 路由地址
 * @param data 路由信息
 * @returns componentTitle 标题
 */
const getTitle = (component, data) => {
  let componentTitle;
  state.menu.forEach(p => {
    if (p.component && component === p.component) {
      componentTitle = p.title;
    }
    p.value.forEach(t => {
      if (component === t.component) {
        componentTitle = t.title;
      }
    });
  });
  if (componentTitle) {
    if (component === 'order-setting-detail') {
      const orderObj = CONSTANT.ORDER_TYPE;
      componentTitle += orderObj[data.routerInfo.params.orderType];
    }
    return componentTitle;
  }
  // console.error('获取标题出错！', component);
  return null;
};

const getters = {};
const mutations = {
  /**
   页面切换方法
   @param s state
   @param data 数据
   */
  addTab(s, data) {
    const titleObj = CONSTANT.ORDER_TYPE;
    let isHaveFlag = false;
    const newDataPath = data.routerInfo ? data.routerInfo.path : data.path;
    s.tabs.forEach(tab => {
      // 遍历查找是否有该页面
      if (tab.component === data.component) {
        if (tab.component === 'order-setting-detail') {
          if (tab.title === `单据模版-${titleObj[data.routerInfo.params.orderType]}`) {
            isHaveFlag = true;
          }
        } else {
          isHaveFlag = true;
          if (tab.path !== newDataPath) {
            tab.path = newDataPath;
            tab.pathUpdate = true;
          }
        }
      }
    });
    const title = data.title ? data.title : getTitle(data.component, data);
    if (title === null) {
      // 404直接跳my-info
      // console.error('error');
    }
    s.view = {
      title,
      component: data.component,
      path: newDataPath
    };
    if (!isHaveFlag && title) {
      s.tabs.push({
        title,
        component: data.component,
        path: newDataPath
      });
    }
    setKeepAliveTabs(s);
  },
  /**
   tab点击切换方法
   @param s state
   @param data 数据
   */
  selectTab(s, data) {
    s.tabs.forEach(tab => {
      if (tab.title === data.title) {
        s.view = { title: tab.title, component: tab.component, path: tab.path };
      }
    });
  },
  /**
   @description 删除tab方法
   @param s state
   @param data 数据
   */
  deleteTab(s, data) {
    if (s.tabs.length === 1 && s.view.title === '大货发货通知单') {
      return;
    }
    let removeIndex = -1;
    removeIndex = s.tabs.findIndex(tab => tab.title === data.item);
    const pushFlag = s.tabs[removeIndex].component === s.view.component;
    let pushIndex = 0;
    if (removeIndex !== -1) {
      if (removeIndex === 0) {
        s.tabs.splice(0, 1);
      } else if (removeIndex === s.tabs.length - 1) {
        s.tabs.splice(removeIndex, 1);
        pushIndex = removeIndex - 1;
      } else {
        s.tabs.splice(removeIndex, 1);
        pushIndex = removeIndex;
      }
      if (data.pushUrl) {
        router.push(data.pushUrl);
        s.update = true;
        return;
      }

      if (pushFlag) {
        if (s.tabs.length < 1) {
          router.push('/');
          return;
        }
        router.push(s.tabs[pushIndex].path);
      }
    }
    setKeepAliveTabs(s);
  },
  afterUpdate(s) {
    s.update = false;
  },
  clearPathUpdate(s, tab) {
    s.tabs.forEach(e => {
      if (e.path === tab.path) {
        e.pathUpdate = false;
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
